import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "./HeroSection/assets/logo.png";
import EmailPopup from "./EmailPopup";

const Navbar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setShowButton(false);
    }
  }, []);

  const handleGetStarted = () => {
    setShowPopup(true);
  };

  return (
    /* add navbar--open while menu is open */
    <nav className={`new-navbar ${open ? "navbar--open" : ""}`}>
      {/* ── row‑1 : logo + burger ───────────────────────────── */}
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Upskillmeet" className="logo-image" />
        </Link>
        {showButton && (
          <>
            {/* desktop buttons (hidden on mobile) */}
            <div className="auth-buttons">
              <button
                className="nav-btn new-signin-btn"
                onClick={() => navigate("../login")}
              >
                Sign&nbsp;In
              </button>
              <button
                className="nav-btn new-getstarted-btn"
                onClick={handleGetStarted}
              >
                Get&nbsp;Started
              </button>
            </div>

            {/* hamburger */}
            <button
              className="hamburger"
              onClick={() => setOpen(!open)}
              aria-label="menu"
            >
              <span /> <span /> <span />
            </button>
          </>
        )}
      </div>

      {/* ── row‑2 : mobile buttons ──────────────────────────── */}
      <div className="mobile-auth">
        <button
          className="nav-btn new-getstarted-btn"
          onClick={handleGetStarted}
        >
          Get&nbsp;Started
        </button>
        <button
          className="nav-btn new-signin-btn"
          onClick={() => navigate("login")}
        >
          Sign In
        </button>
      </div>

      <EmailPopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
    </nav>
  );
};

export default Navbar;
